var exports = {
  "w": "sidebarTooltip__Dvd9ZQ",
};

module.exports = exports;
